// extracted by css-extract-rspack-plugin
export default {"animated":"jojCN","fading":"jHRz5"};